import React, { Component } from "react";
import { Modal, Spin } from "antd";
import "./Form.css";
import Colors from "../utils/Colors";

export default class SpinnerForm extends Component {
  state = {

  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        visualizar: this.props.registroSelecionado.visualizar,
      }, () => {

      });
    }
  }


  render() {
    const { onCancelarClick, carregando, visivel } = this.props;

    return (
      <Modal
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        centered
        maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.6)', borderRadius: 8 }}
        style={{ backgroundColor: 'transparent' }}
        bodyStyle={{ backgroundColor: 'transparent', backgroundColor: Colors.dividerDark, borderRadius: 8 }}
      >
        <div style={{ textAlign: 'center', justifyContent: 'center', alignContent: 'space-between' }}>
          <div style={{ width: '100%', marginTop: 30 }}><Spin spinning={carregando} size="large" fullscreen /></div>
          <div style={{ width: '100%', marginTop: 30, marginBottom: 30 }}><span style={{ fontSize: 18, fontWeight: 'bold' }}>{this.props.texto}</span></div>
        </div>
      </Modal >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SpinnerForm.js